import { Translations } from '../translations.type';

const ja: Translations = {
  lang: '日本語',
  app_title: 'Mahjong BTI',
  app_subtitle: '麻雀人格タイプ診断',
  app_description:
    '16種類の麻雀人格、12問のクイック診断。卓上のあなたがどんなプレイヤーか確かめてみよう。',
  home_cta_start: '診断を始める',
  home_footnote: '約2分・全12問',

  wizard_progress: (current: number, total: number) =>
    `第${current}問 / 全${total}問`,
  wizard_prev: '前へ',
  wizard_next: '次へ',
  wizard_finish: '結果を見る',
  wizard_pick_hint: '自分に一番近いものを選んでください',

  loading_messages: [
    'あなたの回答を分析しています…',
    '捨て牌を読み解いています…',
    '牌を数えています…',
    'あなたのタイプを確定しています…',
  ],

  result_title: 'あなたは',
  result_subtitle: 'あなたの麻雀人格',
  result_retake: 'もう一度診断する',
  result_share: 'シェア',
  result_share_text: (code: string, name: string) =>
    `私は${code} ——「${name}」。あなたの麻雀人格は?`,
  result_axes_heading: 'あなたの4つの軸',

  share_button: 'シェア',
  share_title: 'Mahjong BTIをシェア',
  share_link_label: 'リンク',
  share_copy: 'リンクをコピー',
  share_copied: 'コピーしました！',
  share_close: '閉じる',
  share_scan_hint: 'またはQRコードを読み取る',
  share_via: 'シェア先',
  share_native: 'シェア…',
  share_default_text:
    'Mahjong BTI — 12問であなたの麻雀パーソナリティを診断。',
  share_on: (network: string) => `${network}でシェア`,

  footer_author: '作者',
  footer_source: 'ソース',

  axis_AD: '攻撃 — 守備',
  axis_BS: '大物手 — 安手',
  axis_CF: '理詰め — 感覚',
  axis_TW: '堅実 — 自由',

  axis_AD_tagline: '勝負どころで、前に出る？それとも引く？',
  axis_BS_tagline: '一発大花火か、それともコツコツ20回の小勝か？',
  axis_CF_tagline: '数字で決めるか、直感で決めるか？',
  axis_TW_tagline: '計画を貫くか、流れに乗って臨機応変か？',

  pole_A: '攻撃',
  pole_D: '守備',
  pole_B: '大物手',
  pole_S: '安手',
  pole_C: '理詰め',
  pole_F: '感覚',
  pole_T: '堅実',
  pole_W: '自由',

  pole_A_description:
    '牌の音を聞いた瞬間に目が光る。手の中の牌は記念品じゃなく、撃ち出すための弾。次の一局は自分のものだと本気で信じて勝負を仕掛ける。我慢は自分の手を信じきれない人のためのもの——あなたには無縁だ。',
  pole_D_description:
    '一晩アガれなくても、放銃だけは絶対にしない。河を茶葉占いのように読み、半端な好形は迷わず崩し、他人同士の衝突を静かに見守る。点棒は減らさず、メンタルも崩れず、翌朝も普通に起きられる。',
  pole_B_description:
    '安手では満足できない。アガれる形を崩してでも、翌日まで語り草になる大物手を狙いに行く。勝つなら自慢できる勝ち方で——できれば受賞スピーチ付きで。',
  pole_S_description:
    '小さく、何度も、止まらずアガる。花火はいらない、必要なのは安定した「ツモ」と少しずつ積み上がる点棒。点数表に手の大小は関係ない、わざわざ残業する理由がない。',
  pole_C_description:
    '河はデータ、待ちは確率、卓全体があなたが解いている表計算シート。運は信じない、信じるのは長期収益——そして長期は平均的にあなたに優しい。分散は天気のようなもの、いずれ晴れる。',
  pole_F_description:
    'なんとなく嫌な牌、なんとなく良い牌——その感覚を否定するのはやめた。予感、空気、「これじゃない」という静かな確信で打つ。宇宙もどういうわけか味方してくれる。懐疑派は牌を数え続ければいい、あなたはアガり続けるだけ。',
  pole_T_description:
    '決めた方針には添い遂げる。気分で打たない、夜中に英雄になろうとしない。規律は地味だが、点数を数える時間になると、卓上で最もカッコいいのは規律だと静かに分かる。',
  pole_W_description:
    '計画は参考、檻ではない。流れが来たら乗り、風向きが変われば曲がる。卓の空気があなたを運ぶ。読みやすい？それはあなたのキャラじゃない——時には自分でも次の一手が読めない、それが楽しい。',

  questions: {
    q1: {
      question: '1巡目、牌をツモった。あなたは:',
      options: [
        'やるぞ——まずは手を組み始める。',
        '焦らない。周りの捨て牌を見てから動く。',
      ],
    },
    q2: {
      question: '相手が明らかにテンパイ間近、しかも大きそうな手。あなたは:',
      options: [
        '競り勝ちにいく——こちらの手も速い。',
        '守備に切り替える。放銃はしない。',
      ],
    },
    q3: {
      question: '最終巡でテンパイ、でも待ちは危険牌。あなたは:',
      options: [
        '勝負牌を切ってアガリを取りに行く。',
        '安牌を切る。アガれなくても失点は避ける。',
      ],
    },
    q4: {
      question: '今すぐ安アガリできるが、崩せば大物手のチャンス。あなたは:',
      options: [
        '崩す——大きい手は待つ価値がある。',
        'アガる。アガリはアガリ。',
      ],
    },
    q5: {
      question: '大きな手の核になりそうな牌を引いた。あなたは:',
      options: [
        'それを軸に組む。今局は大きくする。',
        '頭に入れて、効率重視で打ち続ける。',
      ],
    },
    q6: {
      question: 'あなたの理想の麻雀の夜は:',
      options: [
        '満足度の高い、自慢できる大きな一手。',
        '一晩で20回の小さなアガリ。',
      ],
    },
    q7: {
      question: 'どの牌を切るか決めるとき、主に頼るのは:',
      options: [
        '牌を数え、河を読み、確率を計算する。',
        '直感。正しい牌は感覚で分かる。',
      ],
    },
    q8: {
      question: '連敗が続いた。対処法は:',
      options: [
        '打ち筋を見直して戦略を調整する。',
        '席を変え、手を洗い、お守りを握り直す。',
      ],
    },
    q9: {
      question: '誰かが珍しい待ちを宣言した。あなたは:',
      options: [
        '「確率的に安全牌はX、Y、Z」',
        '「この牌、何か嫌な感じがする。切らない」',
      ],
    },
    q10: {
      question: '局の方針を決めた。途中で:',
      options: [
        '方針を貫く——規律こそ長期的に勝つ。',
        '柔軟に変える。卓が変われば自分も変える。',
      ],
    },
    q11: {
      question: '卓に着くとき、あなたの目的は:',
      options: [
        '本気で打つ。目標は勝つこと。',
        '楽しむ。勝てればおまけ。',
      ],
    },
    q12: {
      question: '3連勝した後、あなたは:',
      options: [
        'ここまでの集中した打ち方を続ける。',
        '気を緩めて、流れに乗って攻めてみる。',
      ],
    },
  },

  types: {
    ABCT: {
      name: '屠龍刀',
      tagline: '冷静、精密、致命的——卓上の暗殺者。',
      description:
        '外科手術のような攻撃。すべての打牌は計算済み、すべての押しはタイミングを見計らっている。仕留めにかかれば外さない。あなたが静かなときほど、卓は安心できる。',
    },
    ABCW: {
      name: 'ギャンブラー神降臨',
      tagline: '大きな手、大きな勝負、大きな存在感。',
      description:
        '派手に、勝つために打つ。卓の流れを読み、勝負どきを見極めて、瞬きもせずに大きく振る。スタイル点もしっかり稼ぐ。',
    },
    ABFT: {
      name: 'モウフ流',
      tagline: '押して押して押す。怖さは後回し。',
      description:
        '我慢は過大評価。攻撃的に組み、攻撃的に押し、直感を信じて突き進む。うまくいけば最高、ダメなら次の局へ。',
    },
    ABFW: {
      name: 'ミスティック',
      tagline: '運に守られ、感覚で動く。',
      description:
        '攻めるが、本当の戦略は「信じる」こと。感覚で牌を動かし、宇宙もそれに応える。懐疑派は運と呼び、あなたは波長と呼ぶ。',
    },
    ASCT: {
      name: '流れ作業の職人',
      tagline: '鳴けるなら鳴く、アガれるならアガる。',
      description:
        '美しさより効率。ポンできればポン、チーできればチー、安手をきれいに、何度も、何度もアガリ切る。',
    },
    ASCW: {
      name: 'スピード暗殺者',
      tagline: '6巡目でテンパイ。',
      description:
        'とにかく速い。他が手を組んでいる間に、あなたはもう待ちに入っている。点は大きくないが、誰よりも早く、何度もアガる。',
    },
    ASFT: {
      name: '満足派',
      tagline: '小さなアガリもアガリ。',
      description:
        '空気を読んで点棒を確保する。花火は不要、静かで繰り返せる勝利が一番心地よい。引き際を知るのも立派な才能。',
    },
    ASFW: {
      name: 'ピンフ王者',
      tagline: '一晩20回、どれも底点。',
      description:
        '一晩中アガり続ける——最小点、最大笑顔。手の大きさはどうでもいい、「ツモ」と言えることが嬉しい。あなたはどの卓のマスコットでもある。',
    },
    DBCT: {
      name: 'こっそり職人',
      tagline: 'アガらず、放銃せず、それでも勝つ。',
      description:
        '卓に溶け込んで存在を消す。アガリは追わず、生き残りを目指す。終わってみれば点棒は静かにあなたの側に積まれ、誰も理由が分からない。',
    },
    DBCW: {
      name: '逆張りオペレーター',
      tagline: '守って…守って…突然の奇襲！',
      description:
        '10巡守り、1巡で押し切る。読みにくさが武器——相手が読み筋を失った瞬間に仕掛ける。',
    },
    DBFT: {
      name: '静かなる稼ぎ手',
      tagline: '口数は少なく、手は大きい。',
      description:
        '騒がず、大きな手を仕上げる。攻撃的に見せる必要はない——宣言する時には、もう手は十分に大きい。劇は少なく、ドラは多く。',
    },
    DBFW: {
      name: '禅マスター',
      tagline: '運命は動じない者に微笑む。',
      description:
        '勝ちも負けも流れる雲。淡々と打っていると、なぜか良い牌が舞い込んでくる。卓はあなたの瞑想の場。',
    },
    DSCT: {
      name: '電卓',
      tagline: '確率はあなたの愛の言葉。',
      description:
        'どの待ちの確率も、何枚切れたかも、すべての一手の期待値も知っている。毎回アガれなくても、毎回正しい選択をする。長期的には勝つのはあなた。',
    },
    DSCW: {
      name: '慎重な冒険者',
      tagline: 'まず計算、それから勇気。',
      description:
        'リスクを取りたい、本当に取りたい——でも数字を確認してから。結果として、慎重で時々驚かせるスタイル。自分自身にも驚かれることがある。',
    },
    DSFT: {
      name: '安全第一',
      tagline: '守備は完成された戦略。',
      description:
        '目標はシンプル——放銃しないこと。生き残りを最優先に、早めに引き、嵐をやり過ごす。皆が点を失ってあなただけ無傷なら、すでに勝者だ。',
    },
    DSFW: {
      name: 'のんびりチャンピオン',
      tagline: 'お菓子を食べに来ました。ついでに打ちます。',
      description:
        '麻雀は付け合わせ、友達がメインディッシュ。ゆるく打って、よく笑い、点数表には目もくれない。実はこれも一種の境地。',
    },
  },
};

export default ja;
